/**
 *
 * v.1.0  10/09/25  Inicial
 * v.1.1  11/09/25 Añadido componentDidUpdate
 **/

import React from 'react'
import PropTypes from 'prop-types';


class InputTextArea extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            valor: props.valor || "",
        };
    }


    componentDidUpdate(prevProps) {
        if (prevProps.valor !== this.props.valor) {
            this.setState({ valor: this.props.valor?.toString() || "" });
        }
    }


    handleChange = (e) => {
        const valor = e.target.value;
        this.setState({ valor });

        // Si quieres notificar en cada tecla, descomenta:
        // if (this.props.onChange) {
        //     this.props.onChange(valor);
        // }
    }

    handleBlur = () => {
        let { valor } = this.state;

        console.log("on blur");
        this.setState({ valor });
        if (this.props.onChange) {
            this.props.onChange(valor);
        }
    };

    render() {
        const {valor} = this.state;
        const {numRows} = this.props;
        console.log("RENDER INPUT TEXT AREA");
        return (

            <textarea value={valor}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                      {...(numRows && numRows > 0 ? { rows: numRows} : {})} // 👈 Asignamos filas
            />
        );
    }

}


InputTextArea.propTypes = {
    className: PropTypes.string,
    valor: PropTypes.string,
    onChange: PropTypes.func,
    numRows: PropTypes.number
}

export default InputTextArea